// extracted by mini-css-extract-plugin
export default {"map":"Gis_map__NVI4L","mapContainer":"Gis_mapContainer__sWTTv","category":"Gis_category__YSNfB","details":"Gis_details__Ofup1","showLayerButton":"Gis_showLayerButton__Llr6f"};